import ReorderPostsButton from "./components/ReorderButton"
import EditButton from "./components/EditButton"
import DeleteButton from "./components/DeleteButton"
import { Flex, Title, Text, SmallMessage, AlignCenter } from './styles'
import Button from '../../../../../components/Button'
import Icon from '../../../../../components/Icon'
import pencilIcon from "../../../../../assets/icons/edit-bold.svg";
import trashIcon from "../../../../../assets/icons/trash-bold.svg";
import ServerIcon from '../../../../../assets/icons/server.svg';
import { useEffect, useMemo, useState } from "react"
import Snackbar from "../../../../../components/Snackbar"
import { connect, useDispatch } from "react-redux"
import { resetUpdateCategory } from "../../../../../store/actions/category"
import DeleteSidebar from '../../../../Dashboard/Category/components/DeleteSidebar'
import EditSidebar from '../../../../Dashboard/Category/components/EditSidebar'
import ReorderContentSidebar from '../../../../Dashboard/Category/components/ReorderContentSidebar'
import { useWindowSize } from "../../../../../hooks/useWindowSize"
import FloatingMenu from './components/FloatingMenu'
import Modal from "../../../../../components/Modal"
import { hideModal, showModal } from "../../../../../store/actions/modal"


type MenuItem = {
  label: string;
  icon: React.ReactNode;
  action: any;
  iconBgColor: string;
  labelBgColor: string;
  type: 'button' | 'link';
  width: number
};

const PostPreviewLayoutHeaderMenu = ({ category, updatedCategoryStates, reorderCategoryPostsStates, deleteCategoryStates }) => {
  const { isMobile } = useWindowSize()
  const dispatch = useDispatch()
  const [showEditSidebar, setShowEditSidebar] = useState<boolean>(false)
  const [showDeleteSidebar, setShowDeleteSidebar] = useState<boolean>(false)
  const [showReorderContentSidebar, setShowReorderContentSidebar] = useState<boolean>(false)
  const [countdown, setCountdown] = useState(5);

  const menuItems: MenuItem[] = useMemo(() => [
    {
      label: "Editar categoría",
      icon: <Icon icon={pencilIcon} size="24px" />,
      action: () => setShowEditSidebar(true),
      type: 'button',
      iconBgColor: "transparent",
      labelBgColor: "white",
      width: 205
    },
    {
      label: "Reordenar artículos",
      icon: <Icon icon={ServerIcon} size="24px" />,
      action: () => setShowReorderContentSidebar(true),
      type: 'button',
      iconBgColor: "transparent",
      labelBgColor: "white",
      width: 236
    },
    {
      label: "Eliminar categoría",
      icon: <Icon icon={trashIcon} size="24px" />,
      action: () => setShowDeleteSidebar(true),
      type: 'button',
      iconBgColor: "transparent",
      labelBgColor: "white",
      width: 223
    },
  ], [])

  useEffect(() => {
    if (updatedCategoryStates.success) {
      setShowEditSidebar(false)
      setTimeout(() => {
        dispatch(resetUpdateCategory());
      }, 3500);
    }

    if (updatedCategoryStates.error) {
      setTimeout(() => {
        dispatch(resetUpdateCategory());
      }, 3500);
    }
  }, [updatedCategoryStates]);

  useEffect(() => {
    if (reorderCategoryPostsStates.success) {
      setShowReorderContentSidebar(false)
    }
  }, [reorderCategoryPostsStates]);

  useEffect(() => {
    if (deleteCategoryStates.success) {
      dispatch(showModal("modal-success-delete"))
      if (countdown > 0) {
        const timer = setTimeout(() => {
          setCountdown(countdown - 1);
        }, 1000);

        return () => clearTimeout(timer);
      } else {
        window.location.href = `/dashboard/membership/${category?.group?.id}/posts`;
      }
    }
  }, [deleteCategoryStates, countdown, category]);

  if (!isMobile) {
    return <></>;
  }

  return <>
    {isMobile ? (
      <FloatingMenu menuItems={menuItems} />
    ) : (
      <Flex>
        <EditButton onClick={() => setShowEditSidebar(true)} />
        <DeleteButton onClick={() => setShowDeleteSidebar(true)} />
        <ReorderPostsButton onClick={() => setShowReorderContentSidebar(true)} />
      </Flex>
    )}

    <EditSidebar
      onClose={() => { setShowEditSidebar(false) }}
      isVisible={showEditSidebar}
      category={category}
    />
    <DeleteSidebar
      onClose={() => { setShowDeleteSidebar(false) }}
      isVisible={showDeleteSidebar}
      category={category}
    />
    <ReorderContentSidebar
      onClose={() => { setShowReorderContentSidebar(false) }}
      isVisible={showReorderContentSidebar}
      idCategory={category?.id}
      idGroup={category?.group?.id}
    />

    <Snackbar
      visible={updatedCategoryStates.success || !!updatedCategoryStates.error}
      options={{
        time: 2000,
        type: updatedCategoryStates.success ? "success" : "error",
      }}
    >
      {updatedCategoryStates.success
        ? "Categoría actualizada."
        : "Error al actualizar la categoría."}
    </Snackbar>

    <Snackbar
      visible={reorderCategoryPostsStates.success || !!reorderCategoryPostsStates.error}
      options={{
        time: 2000,
        type: reorderCategoryPostsStates.success ? "success" : "error",
      }}
    >
      {reorderCategoryPostsStates.success
        ? "Categoría actualizada."
        : "Error al actualizar la categoría."}
    </Snackbar>

    <Modal name="modal-success-delete" width="650" onClose={() => { }}>
      <Title>La categoría fue eliminada</Title>

      <Text>
        Serás redirigido a la biblioteca.
      </Text>

      <SmallMessage>Toca "continuar" o aguarda ({countdown} seg.)<br />y serás redirigido </SmallMessage>

      <div style={{ height: 8 }} />

      <AlignCenter>
        <Button
          options={{
            type: "filled",
            skin: "purple",
            size: "lg",
          }}
          onClick={() => {
            dispatch(hideModal())
            window.location.href = `/dashboard/membership/${category?.group?.id}/posts`;
          }}
        >
          Continuar
        </Button>
      </AlignCenter>
    </Modal>
  </>
}

const state = ({ categoryStore }) => {
  const { data: updatedCategory, states: updatedCategoryStates } = categoryStore.updateCategory;
  const { states: reorderCategoryPostsStates } = categoryStore.reorderCategoryPosts;
  const { states: deleteCategoryStates } = categoryStore.deleteCategory;

  return {
    updatedCategory,
    updatedCategoryStates,
    reorderCategoryPostsStates,
    deleteCategoryStates
  };
};

export default connect(state)(PostPreviewLayoutHeaderMenu);